var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconArrowCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.69968 0.692966C8.09214 0.308085 8.72044 0.308085 9.1129 0.692966C9.51634 1.08861 9.51633 1.73839 9.11288 2.13403L5.13245 6.03741L9.11288 9.9408C9.51633 10.3364 9.51634 10.9862 9.1129 11.3819C8.72044 11.7667 8.09214 11.7667 7.69968 11.3819L2.97067 6.74417C2.57495 6.35609 2.57495 5.71874 2.97067 5.33066L7.69968 0.692966Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowCart);
export default __webpack_public_path__ + "static/media/icon_arrow_cart.8b60bc444feab3ead080ff02a102be62.svg";
export { ForwardRef as ReactComponent };